import { render, staticRenderFns } from "./ReclamacionesPQR.vue?vue&type=template&id=c4cdab82&"
import script from "./ReclamacionesPQR.vue?vue&type=script&lang=js&"
export * from "./ReclamacionesPQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports